import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    matches: [],
    teams: [],
    tournament: null,
    players: [],
    tables: [],
    stats: [],
    backConnected: false
  },
  mutations: {
    setMatches(state, value){
      state.matches = value
    },
    setTeams(state, value){
      state.teams = value
    },
    setStats(state, value){
      state.stats = value
    },
    setTournament(state, players){
      state.tournament = players
    },
    setPlayers(state, matches){
      state.players = matches
    },
    setTables(state, matches){
      state.tables = matches
    },
    setBackConnected(state, backConnected){
      state.backConnected = backConnected
    }
  },
  actions: {
  },
  modules: {
  }
})
